import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ContributionsService {
  constructor(private http: HttpClientService) {}

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/contributions/" + id)
      .pipe(tap((_) => console.log("ContributionsService.delete: Ok.")));
  }

  public updateContribution(contribution: any) {
    const options = {
      contribution: contribution,
    };
    return this.http
      .put("/api/contributions/" + contribution.id, options)
      .pipe(tap((_) => console.log("ContributionsService.updateContribution: Ok.")));
  }

  public approveContribution(contribution: any) {
    const options = {
      contribution: contribution,
    };
    return this.http
      .post("/api/contributions/" + contribution.id + "/approve", options)
      .pipe(tap((_) => console.log("ContributionsService.approveContribution: Ok.")));
  }

  public getAll(filters): Observable<any[]> {
    let options = {
      params: filters,
    };
    return this.http
      .get("/api/contributions/all", options)
      .pipe(tap((_) => console.log("ContributionsService.getAll: Ok.")));
  }

  public getContributionsCount(): Observable<any> {
    return this.http
      .get("/api/contributions/contributions_count")
      .pipe(tap((_) => console.log("ContributionsService.getContributionsCount: Ok.")));
  }

  public getPaymentPlanSimulation(contribution_id: number): Observable<any> {
    return this.http
      .get("/api/contributions/" + contribution_id + "/payment_plan_simulation")
      .pipe(tap((_) => console.log("ContributionsService.getPaymentPlanSimulation: Ok.")));
  }
}
